export default "__VITE_ASSET__Cw$CvLVT__"